// Fragment "client self-service settings" — the policy card in SettingsAdmin
// (admin/settings/ClientBookingPolicyCard.jsx + useClientBookingPolicy.js), which
// reads/writes GET|PUT /admin/settings/client-booking (booking_policy.py). Merged
// in ./index.js.
export default {
  fr: {
    "settings.clientBooking.title": "Libre-service client",
    "settings.clientBooking.subtitle": "Permettez à vos client·e·s d'annuler ou de déplacer eux-mêmes leur rendez-vous depuis un lien de leur courriel de confirmation.",
    "settings.clientBooking.master": "Activer le libre-service client",
    "settings.clientBooking.minNotice": "Préavis minimum (heures)",
    "settings.clientBooking.minNoticeHint": "Délai minimum, avant le rendez-vous, pendant lequel un·e client·e peut encore l'annuler ou le déplacer elle-même/lui-même.",
    "settings.clientBooking.save": "Enregistrer",
    "settings.clientBooking.saved": "Enregistré",
    "settings.clientBooking.invalidNotice": "Le préavis minimum doit être un nombre d'heures positif ou nul.",
  },
  en: {
    "settings.clientBooking.title": "Client self-service",
    "settings.clientBooking.subtitle": "Let clients cancel or reschedule their own appointment from a link in their confirmation email.",
    "settings.clientBooking.master": "Enable client self-service",
    "settings.clientBooking.minNotice": "Minimum notice (hours)",
    "settings.clientBooking.minNoticeHint": "How far ahead of the appointment a client may still cancel or reschedule it themselves.",
    "settings.clientBooking.save": "Save",
    "settings.clientBooking.saved": "Saved",
    "settings.clientBooking.invalidNotice": "Minimum notice must be zero or a positive number of hours.",
  },
  es: {
    "settings.clientBooking.title": "Autoservicio del cliente",
    "settings.clientBooking.subtitle": "Permita que los clientes cancelen o reprogramen su propia cita desde un enlace en su correo de confirmación.",
    "settings.clientBooking.master": "Activar el autoservicio del cliente",
    "settings.clientBooking.minNotice": "Aviso mínimo (horas)",
    "settings.clientBooking.minNoticeHint": "Con cuánta antelación a la cita un cliente puede aún cancelarla o reprogramarla por su cuenta.",
    "settings.clientBooking.save": "Guardar",
    "settings.clientBooking.saved": "Guardado",
    "settings.clientBooking.invalidNotice": "El aviso mínimo debe ser un número de horas positivo o cero.",
  },
};
